import React, { Component } from 'react';
import Navbar from '../components/Layouts/Navbar';
import PageSeo from '../components/Common/PageSeo';
import PageTitleArea from '../components/Common/PageTitleArea';
import Footer from '../components/Layouts/Footer';
import DatenschutzContent from '../components/Datenschutz/DatenschutzContent';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';

const Datenschutz = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';
    return (
        <>
            <PageSeo
                title={t('datenschutz_seo_title')}
                description={t('datenschutz_seo_description')}
                canonical={`${baseUrl}/datenschutz/`}
                openGraph={{
                    url: `${baseUrl}/datenschutz/`,
                    title: t('datenschutz_seo_title'),
                    description: t('datenschutz_seo_description'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('datenschutz_seo_ogImageAlt1'),
                            type: 'image/jpeg',
                        },
                        {
                            url: `${baseUrl}/images/datenschutz-og.png`,
                            width: 2000,
                            height: 1080,
                            alt: t('datenschutz_seo_ogImageAlt2'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('datenschutz_seo_title'),
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('datenschutz_seo_keywords')
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no'
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: `https://simplify-data.de/datenschutz/`
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: `https://simplify-data.com/datenschutz/`
                    }
                ]}
            />

            <Navbar />
            <PageTitleArea
                pageTitle={t('datenschutz_page_title')}
                pageDescription={t('datenschutz_page_description')}
            />
            <DatenschutzContent />
            <Footer />
        </>
    );
}

export default Datenschutz;